module.exports = __webpack_public_path__ + "media/images/massage/card-mobile@2x-832802661c0c62e53316124dc5bb40cc.jpg";